import {
    ACTUALIZAR_DISTRIBUCIONES,
    ACTUALIZAR_SUBCUENTAS_DISTRIBUCION,
    ACTUALIZAR_DISTRIBUCIONES_DB,
    CARGANDO_DISTRIBUCIONES,
    ERROR_DISTRIBUCIONES,
    LIMPIAR_ERROR_DISTRIBUCIONES,
} from "./distribucionesActions";

const distribucionesReducer = (state, action) => {
    switch (action.type) {

        case ACTUALIZAR_DISTRIBUCIONES:
        case ACTUALIZAR_DISTRIBUCIONES_DB: {
            return {
                ...state,
                distribuciones: action.payload,
                cargando: true,
                error: ""
            };
        }
        case ACTUALIZAR_SUBCUENTAS_DISTRIBUCION: {
            return {
                ...state,
                subcuentasDistribucion: action.payload,
                cargando: false,
                error: ""
            };
        }
        case CARGANDO_DISTRIBUCIONES: {
            return {
                ...state,
                cargando: true,
                error: ""
            };
        }
        case ERROR_DISTRIBUCIONES: {
            return {
                ...state,
                cargando: false,
                error: action.payload
            };
        }
        case LIMPIAR_ERROR_DISTRIBUCIONES: {
            return {
                ...state,
                error: ""
            };
        }
        default:
            return state;
    }
};

export default distribucionesReducer;
